export const CONSTANTS = {
  NOT_VALID_EMAIL: "Please Enter Valid Email Address",
  REQUIRED_FIELD: "This Field is required",
  PASSWORD_MIN_8: "Password must be minimum of 8 characters",
  PASSWORD_MATCH: "Password must match",
  ONLY_NUMBER: "Only numbers are allowed",
  OTP_LENGTH: "OTP must be of 4 digits in length",
};
